import { Form, Modal, Select } from "antd";
import { useEffect } from "react";
import { useStaffList } from "@/modules/staff/hooks/useStaff";
import { useAssignStaffToTerritory } from "../hooks/useTerritories";
import type { Territory } from "../services/territory.service";

interface TerritoryAssignStaffModalProps {
	territory: Territory | null;
	open: boolean;
	onClose: () => void;
}

export function TerritoryAssignStaffModal({
	territory,
	open,
	onClose,
}: TerritoryAssignStaffModalProps) {
	const [form] = Form.useForm<{ staffIds: string[]; isPrimary: boolean }>();
	const { data: staffData } = useStaffList({
		organizationId: territory?.organizationId ?? "",
		page: 1,
		limit: 100,
	});
	const staffItems = staffData?.data?.items ?? [];
	const { mutate: assignStaff, isPending } = useAssignStaffToTerritory();

	useEffect(() => {
		if (open) {
			form.resetFields();
			form.setFieldValue("isPrimary", true);
		}
	}, [open, form]);

	const handleClose = () => {
		onClose();
		form.resetFields();
	};

	const handleSubmit = () => {
		form.validateFields().then((values) => {
			if (!territory) {
				return;
			}
			assignStaff(
				{
					territoryId: territory.id,
					staffIds: values.staffIds ?? [],
					isPrimary: values.isPrimary ?? true,
				},
				{ onSuccess: handleClose }
			);
		});
	};

	return (
		<Modal
			title={territory ? `"${territory.name}" hududiga xodim biriktirish` : "Xodim biriktirish"}
			open={open}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isPending}
			okText="Biriktirish"
			cancelText="Bekor qilish"
			destroyOnHidden
			width={480}
		>
			<Form form={form} layout="vertical" requiredMark={false} className="mt-4">
				<Form.Item
					name="staffIds"
					label="Xodim"
					rules={[{ required: true, message: "Xodimni tanlang" }]}
				>
					<Select
						mode="multiple"
						placeholder="Xodimlarni tanlang"
						showSearch
						filterOption={(input, option) =>
							(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
						}
						options={staffItems.map((s) => ({
							value: s.id,
							label: `${s.fullname}${s.phoneNumber ? ` (${s.phoneNumber})` : ""}`,
						}))}
					/>
				</Form.Item>

				<Form.Item name="isPrimary" label="Asosiy hudud" initialValue={true}>
					<Select
						options={[
							{ value: true, label: "Ha" },
							{ value: false, label: "Yo'q" },
						]}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
}
